import {request} from "../request/request";

const invitation = {
  findOne: (params) => request.read('/invitation/find', params, true),
  prepare: (data) => request.create('/invitation/prepare', data, true),
  markAsViewed: (invitationId) => request.update(`/invitation/${invitationId}/viewed`, null, true),
};

export {invitation};
